<template>
  <div>
    <div v-if="formData.parts && formData.parts.id">
      <el-radio-group v-model="value" @change="change">
        <el-radio label="fsWarehouse"
          >佛山(库存：{{ formData.parts.fsWarehouse || 0 }})</el-radio
        >
        <el-radio label="tjWarehouse"
          >天津(库存：{{ formData.parts.tjWarehouse || 0 }})</el-radio
        >
        <el-radio label="shWarehouse"
          >上海(库存：{{ formData.parts.shWarehouse || 0 }})</el-radio
        >
         <el-radio label="cdWarehouse"
          >成都(库存：{{ formData.parts.cdWarehouse || 0 }})</el-radio
        >
        <el-radio label="consignmentSale"
          >寄售(库存：{{ formData.parts.consignmentSale || 0 }})</el-radio
        >
      </el-radio-group>
    </div>
    <div v-else>
      <el-radio-group v-model="value" @change="change">
        <el-radio label="fsWarehouse">佛山(库存：0)</el-radio>
        <el-radio label="tjWarehouse">天津(库存：0)</el-radio>
        <el-radio label="shWarehouse">上海(库存：0)</el-radio>
        <el-radio label="cdWarehouse">成都(库存：0)</el-radio>
        <el-radio label="consignmentSale">寄售(库存：0)</el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
export default {
  model: {
    prop: "value",
    event: "click",
  },
  props: {
    formData: Object,
  },
  data() {
    return {
        value:"",
    };
  },
  watch:{
     formData:{
         handler(){
             this.value=this.formData.wareAddress
         },deep:true,immediate:true
     } 
  },
  methods: {
    change() {
      this.$emit("click", this.value);
    },
  },
};
</script>